import { gql } from "@grandvisionhq/graphql";
import { shoppinglistVariantDetailsFragment } from "../../../fragments/operations/fragments/shopping-list.js";
const GET_MY_WISHLIST = gql`
  query GetMyWishlist {
    me {
      id
      wishlist {
        id
        items {
          name
          quantity
          sku
          product {
            brand
            ... on ContactLensProduct {
              id
              productTypeDetails {
                replacementFrequencyAllLocales {
                  value
                  locale
                }
              }
            }
            ... on FrameProduct {
              id
              productTypeDetails {
                offerings {
                  isPrescriptionNeeded
                }
                isOfferedWithPrescriptions
              }
            }
            slug
          }
          variant {
            ...ShoppinglistVariantDetailsFragment
          }
        }
      }
    }
  }
  ${shoppinglistVariantDetailsFragment}
`;
export {
  GET_MY_WISHLIST as default
};
//# sourceMappingURL=get-my-wishlist.js.map
